module.exports = __webpack_public_path__ + "img/certificate.d6000b11.png";